export const data = [
    {
      id: 1,
      name: 'Hersheys Milk Chocolate',
      category: 'milk',
      image:
        'https://media-cldnry.s-nbcnews.com/image/upload/t_fit-560w,f_auto,q_auto:best/rockcms/2022-12/hersheys-milk-chocolate-jp-221209-54ed0a.jpg',
      //price: '$$$$',
    },
    {
      id: 2,
      name: 'Cadbury Dairy Milk Chocolate',
      category: 'milk',
      image:
        'https://media-cldnry.s-nbcnews.com/image/upload/t_fit-760w,f_auto,q_auto:best/rockcms/2022-12/cadbury-milk-chocolate-jp-221209-de449b.jpg',
      //price: '$',
    },
    {
      id: 3,
      name: 'Lindt Milk Chocolate',
      category: 'milk',
      image:
        'https://media-cldnry.s-nbcnews.com/image/upload/t_fit-760w,f_auto,q_auto:best/rockcms/2022-12/lindt-milk-chocolate-jp-221209-542619.jpg',
      //price: '$$',
    },
    {
      id: 4,
      name: 'Dove Milk Chocolate',
      category: 'milk',
      image:
        'https://media-cldnry.s-nbcnews.com/image/upload/t_fit-760w,f_auto,q_auto:best/rockcms/2022-12/dove-milk-chocolate-jp-221209-5573a2.jpg',
      //price: '$$$',
    },
    {
      id: 5,
      name: 'Lindt Dark Chocolate',
      category: 'dark',
      image:
        'https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1637702742-41oN3gr8edL._SL500_.jpg?crop=1xw:1.00xh;center,top&resize=980:*',
      //price: '$$',
    },
    {
      id: 6,
      name: 'Lilys Dark Chocolate',
      category: 'dark',
      image:
        'https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1637702846-51m2danKGtS._SL500_.jpg?crop=1xw:1.00xh;center,top&resize=980:*',
      //price: '$$$',
    },
    {
      id: 7,
      name: 'House Blend Dark Chocolate',
      category: 'dark',
      image:
        'https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1644865574-Choc_Bar_60house_1000x1000.jpg?crop=1xw:1xh;center,top&resize=980:*',
      //price: '$$$$',
    },
    {
      id: 8,
      name: 'Simple Dark Chocolate',
      category: 'dark',
      image:
        'https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1645046276-simple-chocolate-bar-hu-951750_1000x.png?crop=1xw:1xh;center,top&resize=980:*',
      //price: '$',
    },
    {
      id: 9,
      name: 'Greens White Chocolate',
      category: 'white',
      image:
        'https://www.dinnerwithjulie.com/wp-content/uploads/2018/02/Green-Blacks-white-chocolate.jpg',
      //price: '$$',
    },
    {
      id: 10,
      name: 'Lindt White Chocolate',
      category: 'white',
      image:
        'https://m.media-amazon.com/images/I/81zvbczrfeL.jpg',
      //price: '$$$',
    },
    {
      id: 11,
      name: 'Bakers White Chocolate',
      category: 'white',
      image:
        'https://images.freshop.com/00043000081167/48ccc567845874583840598b9fb2a620_large.png',
      //price: '$$$$',
    },
    {
      id: 12,
      name: 'Ghirardelli White Chocolate',
      category: 'white',
      image:
        'https://target.scene7.com/is/image/Target/GUEST_9395cc76-703c-494c-a27b-8c5b57cf6b4b?wid=488&hei=488&fmt=pjpeg',
      //price: '$',
    },
    {
      id: 13,
      name: 'Cadbury',
      category: 'caramelized',
      image:
        'https://cdn.bestcovery.ca-times-dam.psdops.com/dims4/default/39d08fb/2147483647/strip/true/crop/750x500+0+0/resize/840x560!/quality/90/?url=http%3A%2F%2Fbestcovery-brightspot.s3.amazonaws.com%2F65%2F93%2F422e991247c08a9d463e586dec7e%2Fcadbury-chocolate-caramel-bar-bestcovery.jpg',
      //price: '$$',
    },
    {
      id: 14,
      name: 'Kit Kat',
      category: 'caramelized',
      image:
        'https://media.istockphoto.com/id/458701489/photo/kitkat-chocolate-candy-bar-unwrapped.jpg?s=612x612&w=0&k=20&c=qB0HgAfa1iAzjCKx6Wj3u5iaTFV65A1umtXFq0ZM5PA=',
      //price: '$$$$',
    },
    {
      id: 15,
      name: 'Snickers',
      category: 'caramelized',
      image:
        'https://media.istockphoto.com/id/458543379/photo/snickers-candy-bar.jpg?s=612x612&w=0&k=20&c=8gBxCIH6zMkA73tIH8mbEZMY-ReGVqtWPdVwWuDLbS4=',
      //price: '$',
    },
    {
      id: 16,
      name: 'Mars',
      category: 'caramelized',
      image:
        'https://media.istockphoto.com/id/458955961/photo/mars-minis-candy-bars.jpg?s=612x612&w=0&k=20&c=jk3wGbUawqfQpiarWykcw3e4Ogpik79zxYcCADS6Kt8=',
      //price: '$$$',
    },
  ];
  
  export const categories = [
    {
      id: 1,
      name: 'Toblerone',
      image:
        'https://1000logos.net/wp-content/uploads/2022/10/Toblerone-Logo-1999.png',
    },
    {
      id: 2,
      name: 'Cadbury',
      image:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Cadbury.svg/1280px-Cadbury.svg.png',
    },
    {
      id: 3,
      name: 'Kit Kat',
      image:
        'https://www.nestle.com/sites/default/files/kitkat-logo-square-2023.png',
    },
    {
      id: 4,
      name: 'Ferrero',
      image:
        'https://logowik.com/content/uploads/images/ferrero-rocher5333.jpg',
    },
    {
      id: 5,
      name: 'Lindt',
      image:
        'https://1000logos.net/wp-content/uploads/2020/07/Lindt-Logo.png',
    },
    {
      id: 6,
      name: 'Ritzbury',
      image:
        'https://www.cblmuncheebd.com/assets/media/cbl-web2png.png',
    },
    {
      id: 7,
      name: 'Snickers',
      image:
        'https://m.media-amazon.com/images/I/51JObrhv-lL.jpg',
    },
    {
      id: 8,
      name: 'Kandos',
      image:
        'https://kandos.lk/build/images/logo.d538ca27.png',
    },
  ];
  